import app from '../../../scripts/app';
import template from './ad-submit-buttons.jade';
import { trackSendClick, trackTryToSend, trackPublishByMoneyFailed } from './AdSubmitButtons.tracking';
import { selectAnalyticsProduct } from '../../../../../shared/selectors/analytics';
import {
  selectIsByHomeowner,
  selectIsNewOffer,
  selectIsPublishedOffer,
  selectOfferCategory,
  selectOfferId,
} from '../../../../../shared/selectors/offer';
import { trackPublishWithVisibleViolationsClick } from '../../../../../shared/components/VisibleViolationsWarning/VisibleViolationsWarning.tracking';
import { selectIsSaveDraftButtonAvailable } from '../../../../../shared/selectors/checkoutInfo';
import { selectIsShortForm } from '../../../../../shared/selectors/layout';
import { openModal } from '../../../../../shared/utils/modals';
import { selectIsPublishToHiddenBase } from '../../../../../shared/selectors/publishAvailable';

app.directive('cianAfAdSubmitButtons', [
  'pubAvailService',
  'placingTermsApi',
  'retryService',
  'addFormService',
  'hiddenBaseService',
  '$rootScope',
  'userIdentificationService',
  'jkService',
  'bsCenterService',
  'geoService',
  'deviceService',
  'store',
  'config',
  'formIdService',
  function (
    pubAvailService,
    placingTermsApi,
    retryService,
    addFormService,
    hiddenBaseService,
    $rootScope,
    userIdentificationService,
    jkService,
    bsCenterService,
    geoService,
    deviceService,
    store,
    config,
    formIdService,
  ) {
    return {
      template,
      scope: {},
      bindToController: {
        ad: '=',
        form: '=',
      },
      controller: [
        function () {
          const state = store.getState();
          const isNewOffer = selectIsNewOffer(state);

          const lkUrl = config.get('lkUrl');
          const lkIdentificationUrl = `${lkUrl}identification`;

          this.placingTermsApi = placingTermsApi;
          this.pubAvailService = pubAvailService;

          this.isMobile = deviceService.isMobile;

          this.isMobileSupportVisible = () => {
            const state = store.getState();
            const isByHomeowner = selectIsByHomeowner(state);

            const geoLocation = addFormService.ad.geo;
            const isNiNo =
              geoLocation && geoLocation.userInput && geoLocation.userInput.toLowerCase().includes('нижний новгород');

            return this.isMobile && geoService.userGeo && isByHomeowner && (geoService.userGeo.id === 4596 || isNiNo);
          };

          this.saveOfferDraft = () => {
            this.ad.status = 'draft';
          };

          const isPaidOffer = () => {
            const state = store.getState();
            const isPublishToHiddenBase = selectIsPublishToHiddenBase(state);

            return (
              !isPublishToHiddenBase &&
              placingTermsApi.checkServiceData &&
              placingTermsApi.checkServiceData.actionDescription
            );
          };

          this.publishOffer = $event => {
            const { option } = placingTermsApi.selected;

            const state = store.getState();
            const isPublishedOffer = selectIsPublishedOffer(state);
            const isShortForm = selectIsShortForm(state);
            const category = selectOfferCategory(state);
            const offerId = selectOfferId(state);

            if (placingTermsApi.isSubscriptionOption(option)) {
              if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
              }

              openModal('PackageBuyConfirmationModal');

              return false;
            }

            if (!isPublishedOffer) {
              trackSendClick(
                this.getPublishButtonText() === 'Разместить и оплатить',
                isShortForm,
                formIdService.getId(),
              );
            }

            if (placingTermsApi.shouldPayByCard()) {
              if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
              }

              placingTermsApi.showRefillAccountPopup('add_offer');

              trackPublishByMoneyFailed({ isShortForm, offerId });

              return false;
            }

            trackTryToSend(isShortForm, category);

            // отменяем запрос к чек-сервису, чтобы при задержках не показывать ошибку и не менять текст кнопки после сабмита
            placingTermsApi.cancelCheckServiceRequest();

            this.ad.status = 'published';

            return true;
          };

          this.showRetryNotice = retryService.showRetryNotice;
          this.runRetry = retryService.runRetry;

          this.adStatusText = isNewOffer ? 'публикацию' : 'редактирование';

          // текст кнопки "разместить" берется из сервиса check-service, при ошибках - дефолтное значение
          this.getPublishButtonText = () => {
            const state = store.getState();
            const isPublishedOffer = selectIsPublishedOffer(state);

            if (isPaidOffer()) {
              return placingTermsApi.checkServiceData.actionDescription;
            } else {
              return isPublishedOffer ? 'Сохранить изменения' : 'Разместить';
            }
          };

          this.showPremoderationError = false;

          this.handleSkipPremoderationErrorsClick = () => {
            const state = store.getState();
            const analyticsProduct = selectAnalyticsProduct(state);

            trackPublishWithVisibleViolationsClick(analyticsProduct);

            openModal('premoderationConfirm');
          };

          this.publishOfferWithIdentification = () => {
            const state = store.getState();
            const isShortForm = selectIsShortForm(state);

            trackSendClick(false, isShortForm, formIdService.getId());

            userIdentificationService.setIsSaveInProcess(true);

            this.saveOfferDraft();
          };

          const isPublishButtonAvailable = () => {
            return (
              hiddenBaseService.isEnabled() ||
              (pubAvailService.isAvailable && placingTermsApi.terms.isAvailable && !this.showRetryNotice())
            );
          };

          this.isPublishButtonDisabled = () => {
            return (
              this.form.$pending ||
              addFormService.hasBlockingActions() ||
              !!placingTermsApi.auctionBetValidate(
                placingTermsApi.auctionOption && placingTermsApi.auctionOption.dynamicPrice,
                placingTermsApi.stepBet,
                typeof placingTermsApi.stepBet !== 'undefined',
              ) ||
              // Для коммерческой разрешена публикация в проблемных ЖК
              (jkService.hasProblems() && !bsCenterService.isBSCategory())
            );
          };

          // Возможна ли публикация с предварительной идентификацией sumsub?
          const isPublishViaIdentificationAvailable = () => {
            return pubAvailService.isNeedIdentification && !this.showRetryNotice();
          };

          const isSubmitAvailable = () => {
            return !pubAvailService.pubAvailData?.identificationInstruction?.onlyDocumentsAllowed;
          };

          this.isSubmitWithErrorAvailable = () => {
            return this.showPremoderationError && isSubmitAvailable();
          };

          this.isSaveDraftAvailable = () => {
            const state = store.getState();

            return selectIsSaveDraftButtonAvailable(state);
          };

          this.isTrySubmitOneMoreTimeAvailable = () => {
            return this.showRetryNotice() && isSubmitAvailable();
          };

          this.isPublishAvailable = () => {
            return isPublishButtonAvailable() && isSubmitAvailable();
          };

          this.isPublishWithIdentificationAvailable = () => {
            const state = store.getState();
            const isByHomeowner = selectIsByHomeowner(state);

            return !this.isPublishAvailable() && isPublishViaIdentificationAvailable() && isByHomeowner;
          };

          $rootScope.$on('premoderationErrors', show => {
            this.showPremoderationError = show;
          });

          $rootScope.$on('identification.runSumsub', () => {
            this.publishOfferWithIdentification();
            userIdentificationService.setIdentificationLink(lkIdentificationUrl);

            $rootScope.$broadcast('publishAd');
          });

          $rootScope.$on('simulateSubmitClick', () => {
            if (this.publishOffer()) {
              $rootScope.$broadcast('publishAd');
            }
          });
        },
      ],
      controllerAs: 'adSubmitButtons',
      replace: true,
    };
  },
]);
